import type { DriverComponents } from "./types";

const registry = new Map<string, DriverComponents>();

export function registerDriver(
  gateway: string,
  components: DriverComponents,
): void {
  registry.set(gateway, components);
}

export function getDriver(gateway: string): DriverComponents {
  const driver = registry.get(gateway);
  if (!driver) {
    throw new Error(`No driver registered for gateway: ${gateway}`);
  }
  return driver;
}

/** @internal Test-only reset */
export function _resetForTests(): void {
  registry.clear();
}
